import React, { createContext, useContext } from 'react';
import { usePortalEmployee } from './usePortalEmployee';

const PortalEmployeeContext = createContext(null);

/** Single employee scope for all portal pages — avoids duplicate lookups / desynced banners. */
export function PortalEmployeeProvider({ children }) {
  const value = usePortalEmployee();
  return (
    <PortalEmployeeContext.Provider value={value}>
      {children}
    </PortalEmployeeContext.Provider>
  );
}

export function usePortalEmployeeContext() {
  const ctx = useContext(PortalEmployeeContext);
  if (!ctx) {
    throw new Error('usePortalEmployeeContext must be used within PortalEmployeeProvider');
  }
  return ctx;
}
